module.exports = __webpack_public_path__ + "static/media/SHSNMedium.c673867b.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/SHSNMedium.ttf
// module id = 1029
// module chunks = 3